import { createReducer } from "reduxsauce";
import _ from "lodash";
import UIDs from "../../../UIDs";

import ReducerRegister from "../../ReducerRegister";
import { ActionTypes } from "../../actionTypes/screens/me/RewardPlanListActionTypes";
import RewardPlanListService from "../../../services/screens/me/RewardPlanListService";
import AsyncActionReducers from "../../AsyncActionReducers";

//
// Actions
//
const Actions = {
    loadScreenViewAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });

            RewardPlanListService.loadScreenView(
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),
    
    deleteRewardPlanAsync: (id) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.DELETE_REWARD_PLAN_ASYNC, id });

            RewardPlanListService.deleteRewardPlan(
                id,
                response => {
                    dispatch(Actions.deleteRewardPlanSuccess(response, id));
                },
                error => {
                    dispatch(Actions.deleteRewardPlanFailure(error));
                }
            );
        };
    },

    deleteRewardPlanSuccess: (data, id) => ({
        type: ActionTypes.DELETE_REWARD_PLAN_SUCCESS,
        parentType: ActionTypes.DELETE_REWARD_PLAN_ASYNC,
        data,
        id
    }),

    deleteRewardPlanFailure: error => ({
        type: ActionTypes.DELETE_REWARD_PLAN_FAILURE,
        parentType: ActionTypes.DELETE_REWARD_PLAN_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    rewardPlans: [],
    rewardPlansHistory: []
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    const { rewardPlans, rewardPlansHistory } = data.rewardPlanDetails;
    return { ...state, rewardPlans, rewardPlansHistory };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.DELETE_REWARD_PLAN_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.DELETE_REWARD_PLAN_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.DELETE_REWARD_PLAN_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(UIDs.screens.me.rewardPlanList, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
